"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var CustomAccordion = /** @class */ (function () {
    function CustomAccordion() {
        var _this = this;
        this.accordions = document.querySelectorAll("[".concat(constants_1.DATA_ACCORDION, "]"));
        this.accordions.forEach(function (accordion) {
            accordion.addEventListener('click', function () {
                _this.onToggleAccordion(accordion);
            });
        });
    }
    /**
     * Logic for the toggle
     * @param elem
     * @private
     */
    CustomAccordion.prototype.onToggleAccordion = function (elem) {
        if (elem.dataset.toggleAccordion == 'before') {
            var prevSib = elem.previousElementSibling;
            if (prevSib.classList.contains('show')) {
                this.hide(prevSib);
                elem.classList.remove('show');
            }
            else {
                this.show(prevSib);
                elem.classList.add('show');
            }
        }
        else if (elem.dataset.toggleAccordion == 'after') {
            var nextSib = elem.nextElementSibling;
            if (nextSib.classList.contains('show')) {
                this.hide(nextSib);
                elem.classList.remove('show');
            }
            else {
                this.show(nextSib);
                elem.classList.add('show');
            }
        }
    };
    /**
     * This method adds the show class and set the max-height of the accordion element
     * @param elem
     * @private
     */
    CustomAccordion.prototype.show = function (elem) {
        elem.classList.add('show');
        elem.style.maxHeight = elem.scrollHeight + 'px';
    };
    /**
     * This method removes the show class and set the max-height of the accordion element
     * @param elem
     * @private
     */
    CustomAccordion.prototype.hide = function (elem) {
        elem.classList.remove('show');
        elem.style.maxHeight = 0 + 'px';
    };
    return CustomAccordion;
}());
exports.default = CustomAccordion;
